/* Norrviva — homepage Curator.io feed renderer.
 *
 * Finds .nvv-home-journal__row--curator elements, fetches the latest N
 * posts from Curator.io's free public JSON endpoint, and replaces the
 * placeholder skeleton tiles with our own clean markup. No Curator
 * widget chrome — we own the DOM and the styling.
 *
 * If the fetch fails (network, rate-limited, feed renamed), the
 * skeleton row is hidden and, when the section carries journal_card
 * blocks, its hidden manual-cards fallback list ([data-curator-fallback])
 * is revealed instead.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://api.curator.io/v1/feeds/';

  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  /* ----------------------------------------------------------------
   * Helpers
   * ---------------------------------------------------------------- */
  function clamp(str, max) {
    if (!str) return '';
    if (str.length <= max) return str;
    // Trim to max, then back to the last space, then add an ellipsis.
    var cut = str.slice(0, max);
    var lastSpace = cut.lastIndexOf(' ');
    if (lastSpace > max * 0.6) cut = cut.slice(0, lastSpace);
    return cut.trim().replace(/[.,;:!?-]+$/, '') + '…';
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    // "27 Aug 2025" — short, language-agnostic enough for the strip.
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function setImageWidth(src, width) {
    if (!src) return src;
    // Curator URLs already carry ?width=480 by default. Swap it.
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + width);
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ----------------------------------------------------------------
   * Renderer
   * ---------------------------------------------------------------- */
  function renderTile(post, opts) {
    var img = setImageWidth(post.image, opts.imgWidth);
    var caption = clamp(post.text || '', 140);
    var date = formatDate(post.source_created_at);
    var sourceLabel = opts.sourceLabel || 'Instagram';
    var eyebrow = sourceLabel;
    if (date) eyebrow += ' · ' + date;

    var li = document.createElement('li');
    li.className = 'nvv-home-journal__tile';
    li.innerHTML = '' +
      '<a class="nvv-home-journal__tile-link" href="' + escapeHtml(post.url || '#') + '" target="_blank" rel="noopener">' +
        '<div class="nvv-home-journal__tile-img">' +
          (img
            ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(caption || sourceLabel) + '" loading="lazy">'
            : '<div class="ph" aria-hidden="true"></div>') +
        '</div>' +
        (opts.showMeta
          ? '<div class="nvv-home-journal__tile-eyebrow caption">' + escapeHtml(eyebrow) + '</div>'
          : '') +
        (caption
          ? '<p class="nvv-home-journal__tile-title">' + escapeHtml(caption) + '</p>'
          : '') +
      '</a>';
    return li;
  }

  function paint(root, posts, opts) {
    // Replace the entire list contents with the new tiles.
    var frag = document.createDocumentFragment();
    posts.forEach(function (p) { frag.appendChild(renderTile(p, opts)); });
    root.innerHTML = '';
    root.appendChild(frag);
    root.setAttribute('data-state', 'ready');
  }

  function failQuiet(root) {
    // Fail clean: never leave dead skeleton tiles on the page. If the
    // section rendered a manual-cards fallback list (journal_card blocks
    // exist), reveal it; otherwise collapse the skeleton row so only the
    // section head (title + all-entries link) remains. Keep a data
    // attribute for diagnostics.
    root.setAttribute('data-state', 'error');
    root.hidden = true;
    var section = root.closest('.nvv-home-journal');
    var fallback = section && section.querySelector('[data-curator-fallback]');
    if (fallback) fallback.hidden = false;
  }

  function init(root) {
    var feedId = root.getAttribute('data-curator-feed');
    var count = parseInt(root.getAttribute('data-count'), 10) || 3;
    var imgWidth = parseInt(root.getAttribute('data-img-width'), 10) || 720;
    var sourceLabel = root.getAttribute('data-source-label') || 'Instagram';
    var showMeta = root.getAttribute('data-show-meta') !== 'false';

    if (!feedId) { failQuiet(root); return; }

    var url = ENDPOINT + encodeURIComponent(feedId) + '/posts?limit=' + count;
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('curator http ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.success || !Array.isArray(data.posts) || !data.posts.length) {
          throw new Error('curator empty');
        }
        paint(root, data.posts.slice(0, count), {
          imgWidth: imgWidth,
          sourceLabel: sourceLabel,
          showMeta: showMeta
        });
      })
      .catch(function (err) {
        if (window && window.console) console.warn('[nvv curator]', err);
        failQuiet(root);
      });
  }

  ready(function () {
    document.querySelectorAll('.nvv-home-journal__row--curator').forEach(init);
  });
})();
